import { render, staticRenderFns } from "./certifyQuery.vue?vue&type=template&id=1566e639"
import script from "./certifyQuery.vue?vue&type=script&lang=js"
export * from "./certifyQuery.vue?vue&type=script&lang=js"
import style0 from "./certifyQuery.vue?vue&type=style&index=0&id=1566e639&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports